import { enumOverrideType } from "../constants";
import { QObjDBObject } from "../CoreApp/QObjDBObject";
import { QPlanManager } from "../CoreApp/QPlanManager";

export const kPlanBoxCommands = {
  edit: "editBox",
  move: "moveBox",
  moveOut: "moveOutBox",
  addSub: "addSubBox",
  comment: "addComment",
  delete: "deleteBox",
  modify: "modifyOverride"
} as const;

export type PlanBoxCommand = (typeof kPlanBoxCommands)[keyof typeof kPlanBoxCommands];

// The "Add subordinate" action opens the editor on a brand-new vacant child rather
// than on the clicked box, so the placeholder record is built up front.
function buildVacantChild(planMgr: QPlanManager, parentObj: QObjDBObject): QObjDBObject {
  const takenRefIDs = planMgr
    .GetChangesOfType(enumOverrideType.add)
    .map((item: QObjDBObject) => item.SmartGetFieldValue("RefID"));

  let candidateCount = 0;
  let candidateName = "NEW_0000";
  while (takenRefIDs.indexOf(candidateName) > -1) {
    candidateCount += 1;
    candidateName = "NEW_" + String(candidateCount).padStart(4, "0");
  }

  const newDBObj = new QObjDBObject();
  newDBObj.InitObject(parentObj.GetParentClass());
  newDBObj.SmartSetFieldValue("SupervisorID", parentObj.GetObjectRecordID());
  newDBObj.SmartSetFieldValue("PersonID", candidateName);
  newDBObj.SmartSetFieldValue("Name", "Vacant"); //TODO: This should have been localized?
  newDBObj.SmartSetFieldValue("Title", "");
  newDBObj.SmartSetFieldValue("Location", "");
  newDBObj.SmartSetFieldValue("Division", "");
  newDBObj.fParent = parentObj;

  return newDBObj;
}

export function ExecutePlanBoxCommand(
  planMgr: QPlanManager,
  dbObj: QObjDBObject,
  cmdCode: string
): boolean {
  // Aux instances carry no changes of their own — act on the base record.
  let targetObj = dbObj;
  if ((targetObj.SmartGetFieldValue("isAux") as number) > 0) {
    targetObj = targetObj.FindAuxBaseRecord(planMgr as any);
  }

  let changeType = "";
  switch (cmdCode) {
    case kPlanBoxCommands.edit:
      changeType = enumOverrideType.change;
      break;
    case kPlanBoxCommands.move:
      changeType = enumOverrideType.move;
      break;
    case kPlanBoxCommands.moveOut:
      changeType = enumOverrideType.moveout;
      break;
    case kPlanBoxCommands.addSub:
      changeType = enumOverrideType.add;
      targetObj = buildVacantChild(planMgr, targetObj);
      break;
    case kPlanBoxCommands.comment:
      changeType = enumOverrideType.comment;
      break;
    case kPlanBoxCommands.delete:
      changeType = enumOverrideType.delete;
      break;
    case kPlanBoxCommands.modify: {
      const activeOverrideObj = planMgr.GetActiveOverrideObj(targetObj);
      if (!activeOverrideObj) return false;
      changeType = activeOverrideObj.SmartGetFieldValue("Type") as string;
      break;
    }
    default:
      return false;
  }

  planMgr.HandleEditModalOpen(targetObj, changeType);

  return true;
}
